import React from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { router } from "router";
import { AppProviders } from "providers/AppProviders";
import { initApp } from "init";

// Run global one-time setup
initApp();

// Render the React app into the DOM element
createRoot(document.getElementById("app") as HTMLElement).render(
  <React.StrictMode>
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  </React.StrictMode>,
);
